<!-- 销售退货 0 添加 1 查看 2 编辑 3 无订单模式 4 修改 -->
<template>
    <div class="salereturn-order-edit">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <!--form-->
        <div class="section-title">
            <div>
                <span>售后订单信息</span>
                <span v-if="submitData.EntpCusOId != ''">关联的销售单号：{{ orderCode }}</span>
                <span v-if="returnCode != ''">售后单号：{{ returnCode }}</span>
                <span v-if="isUseSource && submitData.EntpCusOId != ''" style="display: inline-block; position: absolute; right: 165px"
                    >销售单来源：{{ submitData.CusSourcesName }}</span
                >
            </div>
            <div>
                <el-button
                    size="small"
                    class="search-btn btn-primary"
                    @click.stop="submitForm(0)"
                    v-if="(type == 2 || type == 3 || type == 0) && permission.save"
                    :disabled="stopSubmit"
                    >{{ permission.save }}</el-button
                >
                <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(1)" v-if="type != 1 && permission.submit" :disabled="stopSubmit">{{
                    permission.submit
                }}</el-button>
            </div>
        </div>
        <div class="order-infoes">
            <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="入仓仓库" prop="WarehouseId">
                                <el-input
                                    v-if="dataReadonly || submitData.WarehousedCount > 0 || submitData.IsERPOrder"
                                    :title="submitData.WarehouseName"
                                    v-model="submitData.WarehouseName"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    v-model="submitData.WarehouseId"
                                    :disabled="dataReadonly"
                                    placeholder="请选择"
                                    style="width: 100%"
                                    size="small"
                                    filterable
                                    clearable
                                    @visible-change="warehouseVisibleChange($event)"
                                    @change="warehouseChange"
                                >
                                    <el-option
                                        v-for="optionItem in warehouseList"
                                        :key="optionItem.WarehouseId"
                                        :label="optionItem.WarehouseName"
                                        :value="optionItem.WarehouseId"
                                    >
                                        <span style="float: left">
                                            {{ optionItem.WarehouseName }}
                                        </span>
                                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="选择客户" prop="EntpCusId">
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    :disabled="type == 0 || type == 1 || submitData.EntpCusOId != '' || submitData.ApplyIsConfirm"
                                    v-model="submitData.EntpCusId"
                                    filterable
                                    clearable
                                    remote
                                    :remote-method="searchCustomer"
                                    v-select-scroll-more="searchCustomLoad"
                                    @visible-change="customerVisibleChange($event)"
                                    reserve-keyword
                                    placeholder="选择客户"
                                    @change="selectCustomerChange($event)"
                                >
                                    <el-option
                                        v-for="optionItem in customerList"
                                        :key="optionItem.EntpCusId"
                                        :data-msg="optionItem"
                                        :label="optionItem.EntpCusName"
                                        :value="optionItem.EntpCusId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <!--售后单：财务未确认收款前，可更改客户-->
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="售后时间" prop="ReturnTime">
                                <el-date-picker
                                    style="width: 100%"
                                    size="small"
                                    :disabled="dataReadonly"
                                    v-model="submitData.ReturnTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5" v-if="isOrgShow">
                        <div class="grid-content bg-purple">
                            <el-form-item label="部门" prop="OrgId" key="org">
                                <el-input
                                    size="small"
                                    v-if="type == 1 || dataReadonly || (type != 3 && submitData.OrgId !== '')"
                                    disabled
                                    v-model="submitData.OrgName"
                                ></el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="type != 3 && submitData.OrgId !== ''"
                                    v-model="submitData.OrgId"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="orgChange($event)"
                                    @visible-change="orgVisibleChange($event)"
                                    placeholder="请选择"
                                    :key="orgSelKey"
                                >
                                    <el-option v-for="optionItem in orgList" :key="optionItem.Id" :data-msg="optionItem" :label="optionItem.Name" :value="optionItem.Id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="isOrgShow ? 4 : 5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="源开单员" prop="OrderSId">
                                <el-input size="small" v-if="type == 1 || dataReadonly" disabled v-model="submitData.OrderSName"></el-input>
                                <el-select
                                    v-else
                                    v-model="submitData.OrderSId"
                                    disabled
                                    filterable
                                    clearable
                                    placeholder="请选择"
                                    @change="sIdChange($event)"
                                    @visible-change="siVisibleChange($event)"
                                    style="width: 100%"
                                    size="small"
                                >
                                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="发货方式" prop="ShipType">
                                <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                    <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="物流公司" prop>
                                <el-input
                                    v-if="dataReadonly"
                                    :title="submitData.LogisticName"
                                    v-model="submitData.LogisticName"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    size="small"
                                    v-model="submitData.LogisticItem"
                                    value-key="EntpCusId"
                                    placeholder="请输入物流公司"
                                    filterable
                                    clearable
                                    default-first-option
                                    remote
                                    reserve-keyword
                                    :remote-method="searchLogistic"
                                    @visible-change="logisticVisibleChange($event)"
                                    @change="logisticChange"
                                >
                                    <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item">
                                        <div class="name">
                                            {{ item.EntpCusName }}
                                            <span class="phone" v-if="item.Phone">
                                                {{ ' ( 电话：' + item.Phone + ' )' }}
                                            </span>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <div class="customer-view">
                            <el-form-item label="售后原因" prop="Reasons" class="grid-content bg-purple">
                                <el-input size="small" v-model="submitData.Reasons" :disabled="dataReadonly"></el-input>
                            </el-form-item>
                            <div class="customer-checked">
                                <el-checkbox :disabled="dataReadonly" v-model="submitData.IsDeduct">是否标识冲减？</el-checkbox>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="国家" prop="CountryId">
                                <el-input size="small" disabled v-model="submitData.CountryName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="来源店铺" prop="ShopId">
                                <el-input size="small"  disabled v-model="submitData.ShopName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="section-title">
            <div>
                <span>退款申请</span>
                <span v-if="type != 1" style="font-size: 14px; color: red">
                    （ ※ 温馨提醒：当申请退款金额为0时，为仅退货的售后
                    {{ type == 4 ? '，确认收款后不可修改' : '' }}）
                </span>
            </div>
        </div>
        <div class="order-infoes">
            <el-form :model="submitData" ref="formMsg2" label-width="100px" style="width: 100%; padding-right: 30px; padding-left: 30px">
                <el-row :gutter="20">
                    <el-col :span="4" v-if="type != 3 && discountMoney > 0">
                        <div class="grid-content bg-purple">
                            <el-form-item label="订单优惠总额">
                                <el-input size="small" v-model="discountMoney" disabled :title="discountMoney"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="discountMoney > 0 ? 4 : 6" v-if="type != 3">
                        <div class="grid-content bg-purple">
                            <el-form-item :label="type == 0 ? '可退款金额' : '退款金额'">
                                <el-input size="small" v-model="returnMoney" disabled :title="returnMoney"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="discountMoney > 0 ? 4 : 6" v-if="type != 3">
                        <div class="grid-content bg-purple">
                            <el-form-item label="已退款金额">
                                <el-input size="small" v-model="refundAmount" disabled :title="refundAmount"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="退款方式">
                                <el-select
                                    size="small"
                                    v-model="submitData.PayType"
                                    :disabled="dataReadonly || submitData.ApplyIsConfirm"
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="申请退款金额">
                                <el-input-number
                                    v-model="submitData.ApplyAmount"
                                    :disabled="dataReadonly || submitData.ApplyIsConfirm"
                                    :min="0"
                                    style="width: 100%"
                                    size="small"
                                ></el-input-number>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- table body -->
        <div class="section-title">
            <div>
                <span>退货商品</span>
                <span v-if="type != 1" style="font-size: 14px; color: red">
                    （ ※ 温馨提醒：当不选择任何退货商品时，为仅退款的售后{{ type == 4 ? '，已入库的不可修改' : '' }}
                    ）
                </span>
            </div>
            <div>
                <el-button size="small" class="search-btn btn-primary" @click="showOrderSearch()" v-if="!dataReadonly && type != 1 && submitData.EntpCusOId"
                    >选择订单配件</el-button
                >
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="!dataReadonly && type != 1 && !submitData.EntpCusOId"
                    >搜索售后配件</el-button
                >
            </div>
        </div>
        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: true }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
                @selection-change="handleSelectionChange"
                empty-text="该售后单无退货商品"
            >
                <ux-table-column type="checkbox" width="50" class-name="table-check" v-if="type == 0"></ux-table-column>
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65"></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" resizable v-if="type == 0 || type == 1">
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render resizable :filters="[{ data: '' }]" :filter-method="filterAPCodeMethod" v-else>
                    <template v-slot:filter="{ $panel, column }">
                        <el-input
                            type="type"
                            v-for="(option, index) in column.filters"
                            :key="index"
                            v-model="option.data"
                            @input="$panel.changeOption($event, option.data, option)"
                        />
                    </template>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="sapcode"
                            :disabled="dataReadonly || scope.row.WarehousedCount > 0 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            @keyup.enter.native="keyEvent($event, 'APCode', scope.row, scope.rowIndex)"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" resizable v-if="type == 0 || type == 1">
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" edit-render resizable v-else>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="partsNameSelect"
                            style="width: 100%"
                            :disabled="dataReadonly || scope.row.WarehousedCount > 0 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            :title="scope.row.GoodName"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchName(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchNameLoad"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'GoodName')"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" title="车型" resizable v-if="type == 0 || type == 1">
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]">{{ row.AutoSerise }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" title="车型" edit-render resizable v-else>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle('autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="autoSeriseSelect"
                            style="width: 100%"
                            :disabled="dataReadonly || scope.row.WarehousedCount > 0 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSerise"
                            :title="scope.row.AutoSerise"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchAutoSerieLoad"
                            @change="seriseChange($event, scope.rowIndex)"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'AutoSerise')"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                        >
                            <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">{{ option.AutoSerise }}</div>
                                    <div class="project-Name">{{ option.GoodName }}</div>
                                    <div class="project-Name">{{ option.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ option.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="SaleQuantity" v-if="type == 0 && !isBPriceShow" title="销售数量" width="100" key="SaleQuantity">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.SaleQuantity }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="120" key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Origin }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" v-if="isSizeShow" title="规格" key="Size" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="CanReturnCount" v-if="type == 0" title="可退数量" width="110" key="CanReturnCount">
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">可退数量 = 已出仓数 - 已退数量</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">销售数：{{ row.SaleQuantity }}</div>
                            <div class="div-padding-12">{{ row.CanReturnCount }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="80" v-if="!isBPriceShow" key="Unit">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Unit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="退货数量" width="110" :edit-render="{ autofocus: '.el-input__inner' }" key="Count">
                    <template v-slot="{ row }">
                        <div
                            :class="[
                                'div-padding-12',
                                {
                                    'special-border': type == 0 ? row.ReturnCount > row.CanReturnCount : row.ReturnCount == 0
                                }
                            ]"
                        >
                            <span
                                :class="{
                                    'color-red': type == 0 ? row.ReturnCount > row.CanReturnCount : row.ReturnCount == 0
                                }"
                                >{{ row.ReturnCount }}</span
                            >
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                type="number"
                                ref="countRef"
                                :min="1"
                                :max="!submitData.EntpCusOId ? 9999 : scope.row.CanReturnCount"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.ReturnCount"
                                :disabled="dataReadonly || scope.row.IsIn"
                                @change="priceChange"
                                @keyup.enter.native="keyEvent($event, 'Count')"
                                @keyup.right.native="keyEvent($event, 'Count')"
                                @keyup.left.native="keyEvent($event, 'Count')"
                                @focus="selectAutoHandle('countRef')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="ReferencePrice" title="参考退货价" width="100" resizable v-if="!submitData.EntpCusOId" key="ReferencePrice">
                    <template v-slot:header="{ column }">{{ column.title }}</template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            <img
                                v-if="row.EntpTempGoodsId"
                                class="info-icon info-cus-icon"
                                src="@/assets/images/cus.png"
                                title="历史销售"
                                @click.stop="showHistoryDialog(row.EntpTempGoodsId)"
                            />
                            {{ row.ReferencePrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="BillingPrice" title="开单价" width="90" v-if="isBPriceShow" key="BillingPrice">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.BillingPrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="SalePrice" title="退单价" width="120" :edit-render="{ autofocus: '.el-input__inner' }" key="SalePrice">
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格； <br />若配件商品从未销售过，则显示数值0
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip effect="dark" placement="top" :disabled="!row.LatestSalesTime">
                                <div slot="content" style="font-size: 18px">最新售价时间：{{ row.LatestSalesTime }}</div>
                                <div :class="{ 'color-red': row.SalePrice === 0 }">{{ row.SalePrice }}</div>
                            </el-tooltip>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <!--未确认收款收款都可以修改-->
                            <el-input-number
                                ref="marketPirceRef"
                                size="small"
                                :disabled="dataReadonly || submitData.ApplyIsConfirm"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.SalePrice"
                                placeholder="退单价"
                                @change="priceChange"
                                @keyup.enter.native="keyEvent($event, 'MarketPrice')"
                                @keyup.left.native="keyEvent($event, 'MarketPrice')"
                                @keyup.right.native="keyEvent($event, 'MarketPrice')"
                                @focus="selectAutoHandle('marketPirceRef')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="退单总价" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ (row.SalePrice * row.ReturnCount).toFixed(2) }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="是否入仓" width="100" v-if="type == 1 || type == 4">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.IsIn ? '已入仓' : row.WarehousedCount > 0 ? '部分入仓' : '未入仓' }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Remark" title="备注" :edit-render="{ autofocus: '.el-input__inner' }" v-if="isRemarkShow" key="Remark">
                    <template v-slot:header="{ column }">{{ column.title }}</template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.Remark }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="autoSeriseSelect"
                            v-if="isRemarkSelect"
                            allow-create
                            :disabled="dataReadonly"
                            size="small"
                            v-model="scope.row.Remark"
                            :popper-append-to-body="false"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="选择备注"
                            @keyup.enter.native="keyEvent($event, 'Remark')"
                            @keyup.left.native="keyEvent($event, 'Remark')"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in remarkList" :key="option.Value" :data-msg="option" :label="option.Text" :value="option.Text">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 150px">{{ option.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                        <div class="sales-input-cell" v-else>
                            <el-input
                                ref="remarkRef"
                                size="small"
                                :disabled="dataReadonly"
                                v-model="scope.row.Remark"
                                placeholder=" 请输入备注"
                                @keyup.enter.native="keyEvent($event, 'Remark')"
                                @keyup.left.native="keyEvent($event, 'Remark')"
                            ></el-input>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type != 0 && type != 1">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex)"
                                icon="el-icon-delete"
                                v-if="!dataReadonly && (!row.WarehousedCount || row.WarehousedCount <= 0)"
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !dataReadonly && !IsIn && (type == 2 || type == 3 || type == 4)"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex && !row.IsIn"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="entpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="searchVisible" width="1248px" v-dialog-drag :modal="false" lock-scroll id="search-dialog">
            <div v-if="searchVisible">
                <SearchAP
                    dragSign="SearchReturnAP"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="entpCusName"
                    :IsShowBrand="isShowBrand"
                    @closeDialog="closeSearchDialog"
                ></SearchAP>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :title="title"
            :visible.sync="searchOrderVisible"
            width="1248px"
            v-dialog-drag
            :modal="false"
            lock-scroll
            id="search-dialog"
        >
            <div v-if="searchOrderVisible">
                <SearchOrderAP
                    dragSign="SearchOrderReturnAP"
                    :DataList="dataList"
                    :EntpCusOId="submitData.EntpCusOId"
                    :EntpCusName="entpCusName"
                    :IsBPriceShow="isBPriceShow"
                    :IsShowBrand="isShowBrand"
                    @closeDialog="closeSearchDialog"
                ></SearchOrderAP>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APHistory from '@/components/common/APHistory';
import APMsg from '@/components/common/APMsg';
import SearchAP from '@/components/common/APSaleHistoryForReturn';
import SearchOrderAP from '@/components/common/APSaleOrderForReturn';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        breadcrumb,
        APHistory,
        SearchAP,
        SearchOrderAP
    },
    data() {
        return {
            isCheckCode: true,
            returnCode: '',
            orderCode: '',
            returnMoney: '',
            discountMoney: '',
            EntpTempGoodsIdEdit: '',
            needConfirm: true,
            isBPriceShow: false,
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            loading: false,
            dataReadonly: false,
            APMsgVisible: false,
            historyVisible: false,
            searchVisible: false,
            searchOrderVisible: false,
            title: '搜索售后配件',
            allNum: 0,
            allMoney: 0,
            refundAmount: 0,
            submitData: {
                WarehouseId: '',
                SReturnId: '', //退货单id
                EntpCusId: '', //客户id
                EntpCusOId: '', //销售单id
                ReturnTime: new Date(),
                ApplyAmount: 0,
                PayType: '',
                Reasons: '',
                SubmissionState: 0,
                DetailList: [],
                OrgId: '',
                OrgName: '',
                OrderSId: '',
                OrderSName: '',
                IsDeduct: false,
                ShipType: '',
                LogisticId: '',
                LogisticName: '',
                LogisticItem: ''
            },
            Limit: 30,
            codeList: [],
            nameList: [],
            dataList: [],
            logisticsList: [],
            selectedList: [],
            customerList: [], //客户列表
            warehouseList: [],
            payWayList: [],
            DeliveryMethodList: [], // 发货方式列表
            type: 0, //1查看，0新增-有单，2编辑，3新增-无单，4修改
            pageTitle: '',
            entpCusName: '',
            rules: {
                WarehouseId: [{ required: true, message: '选择仓库', trigger: 'change' }],
                EntpCusId: [{ required: true, message: '选择客户', trigger: 'change' }],
                ReturnTime: [{ required: true, message: '填写售后时间', trigger: 'change' }],
                Reasons: [{ required: true, message: '填写售后原因', trigger: 'blur' }],
                OrgId: [{ required: true, message: '请选择部门', trigger: 'change' }]
            },
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            permission: {},
            changeCodeConfig: true,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,

            apcodeSource: null, // 用于处理取消编码请求操作
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于车型列表，分页搜索功能
            seriesList: [],
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: true,
            // 阻止提交，防止多次提交
            stopSubmit: false,
            IsIn: false, //订单是否入库
            // 销售无单售后价格默认赋值商品退货价的合计
            xswdtksqConfig: false,
            // 汽配编码排序标识
            sortActive: '',
            isRemarkShow: false,
            isForceRemark: false,
            isOrgShow: false, //开单部门
            isLastOrg: false,
            orgList: [],
            SIdList: [], //销售单的业务员
            orgSelKey: this.$util.guid(),
            isUseSource: false, //是否启用销售开单显示来源,并且是明细售后和跟单售后才启用
            isShowBrand: false, //是否显示品牌
            startAddChace: false,
            isRemarkSelect: false,
            remarkList: []
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    watch: {
        dataList: {
            deep: 'true',
            handler() {
                // 跟单售后触发
                if (this.type * 1 === 0) {
                    this.totalPriceSum();
                }
                if (this.type * 1 != 1 && this.startAddChace) this.addPageChace();
            }
        },
        submitData: {
            handler() {
                if (this.type * 1 != 1 && this.startAddChace) this.addPageChace();
            },
            deep: true
        }
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            return this.infiniteListHeight - 24;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    created() {
        this.type = this.$route.query.type;
        // this.getConfigByCodes();
        this.getPay();
        this.getSendWay();
    },
    mounted() {
        //销售退货单权限
        this.permission = this.$util.getPermission('ecReturnManage');

        this.submitData.SReturnId = this.$route.query.SReturnId;
        this.submitData.EntpCusOId = this.$route.query.id;
        let orderModel = this.$util.getLocalStorage('ec_salesReturnOrder');
        let datalist = this.$util.getLocalStorage('ec_salesReturnOrder_dataList');

        switch (Number(this.type)) {
            case 1:
                this.pageTitle = '查看销售售后单';
                this.dataReadonly = true;
                this.needConfirm = false;
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    this.getReturnOrderDetail();
                });
                break;
            case 2:
                this.pageTitle = '编辑销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace();
                    } else {
                        this.getReturnOrderDetail(true);
                    }
                });
                break;
            case 3:
                // 从销售退货页面点击新增销售退货
                this.pageTitle = '新增销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace().then(() => {
                            if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                this.getLastOrderOrgId();
                            }
                        });
                    } else {
                        this.addItem();
                        if (this.isOrgShow && this.isLastOrg) {
                            this.getLastOrderOrgId();
                        }
                    }
                });
                break;
            case 4:
                this.pageTitle = '修改销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace();
                    } else {
                        this.getReturnOrderDetail(true);
                    }
                });
                break;
            case 0:
                // 从销售订单点击
                this.pageTitle = '新增销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace().then(() => {
                            if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                this.getLastOrderOrgId();
                            }
                        });
                    } else {
                        this.GetSaleOrderDetail().then(() => {
                            if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                this.getLastOrderOrgId();
                            }
                        });
                    }
                });
                break;
            default:
                break;
        }
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        // 监听滚动事件
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
        if (!(orderModel || (datalist && datalist.length > 0))) this.startAddChace = true;
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'kdbjsd',
                    'ddhhm',
                    'kdyjz',
                    'xswdtksq',
                    'xsthspzsbz',
                    'xsspbzbt',
                    'xskdxskdbm',
                    'kdbmmrsycxz',
                    'xskdxskdj',
                    'kdspcd',
                    'kdspgg',
                    'xsddly',
                    'kdxspp',
                    'xzqpbmdwyx',
                    'xsthspxzbz'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'kdbjsd': //选择商品完成回车或点加号后触发锁定不可修改
                                    this.hasLock = result;
                                    break;
                                case 'ddhhm': // 是否展示互换码
                                    this.changeCodeConfig = result;
                                    break;
                                case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'xswdtksq': // 销售无单售后价格默认赋值商品退货价的合计
                                    this.xswdtksqConfig = result;
                                    break;
                                case 'xsthspzsbz': //展示备注列
                                    this.isRemarkShow = result;
                                    break;
                                case 'xsspbzbt': //备注必填
                                    this.isForceRemark = result;
                                    break;
                                case 'xskdxskdbm': //开单部门
                                    this.isOrgShow = result;
                                    break;
                                case 'kdbmmrsycxz':
                                    this.isLastOrg = result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'xsthspxzbz': //备注下拉选择
                                    this.isRemarkSelect = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        // 搜索客户
        searchCustomer(key) {
            this.loading = true;
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.customerList = [...this.customerList, ...data];
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (currCust) {
                        this.entpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getReturnOrderDetail();
            }
        },
        checkCodeRepeat() {
            let obj = {};
            let result;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    return false;
                } else {
                    result = true;
                }
            }
            return result;
        },
        // 数量或者价格变动
        priceChange(changeApply = true) {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            let ids = [];
            this.selectedList.forEach(x => ids.push(x._XID));

            for (let i = 0; i < DetailList.length; i++) {
                if (this.type == 0) {
                    if (ids.indexOf(DetailList[i]._XID) > -1) {
                        _allNum += Number(DetailList[i].SaleQuantity);
                        _allMoney += Number(DetailList[i].ReturnCount * DetailList[i].SalePrice ? DetailList[i].ReturnCount * DetailList[i].SalePrice : 0);
                    }
                } else {
                    _allNum += Number(DetailList[i].SaleQuantity);
                    _allMoney += Number(DetailList[i].ReturnCount * DetailList[i].SalePrice ? DetailList[i].ReturnCount * DetailList[i].SalePrice : 0);
                }
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            if (this.xswdtksqConfig) {
                //编辑初始化的时候不从这里赋值
                if (typeof changeApply === 'number' || (typeof changeApply === 'boolean' && changeApply)) {
                    this.$nextTick(() => {
                        this.submitData.ApplyAmount = _allMoney.toFixed(2);
                    });
                }
            }
        },
        // 获取销售售后单详情
        getReturnOrderDetail(hasLock) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetSaleReturnOrderDetail_EC',
                    data: {
                        SReturnId: that.submitData.SReturnId
                    }
                })
                .then(res => {
                    let data = res.data;

                    data.LogisticItem = data.LogisticName;
                    let i = that.customerList.findIndex(item => {
                        if (item.EntpCusId == data.EntpCusId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.customerList.push({
                            EntpCusId: data.EntpCusId,
                            EntpCusName: data.EntpCusName
                        });
                        that.entpCusName = data.EntpCusName;
                    }

                    if (data.WarehouseId) {
                        let iw = that.warehouseList.findIndex(item => {
                            if (item.WarehouseId == data.WarehouseId) {
                                return true;
                            }
                        });
                        if (iw == -1) {
                            that.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }
                    }
                    let ip = that.payWayList.findIndex(item => {
                        if (item.Value == data.PayType) {
                            return true;
                        }
                    });
                    if (ip == -1) {
                        that.payWayList.push({
                            Value: data.PayType,
                            Text: data.PayTypeName
                        });
                    }
                    if (data.OrderSId) {
                        that.SIdList.push({
                            EmployeeId: data.OrderSId,
                            EmployeeName: data.OrderSName
                        });
                    }
                    if (that.isOrgShow && data.OrgId) {
                        that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }
                    data.DetailList.forEach(ele => {
                        ele.hasLock = hasLock;
                    });

                    that.submitData = data;
                    that.returnMoney = data.Paid;
                    that.discountMoney = data.DiscountAmount;
                    that.refundAmount = data.RefundAmount;
                    that.returnCode = data.ReturnCode;
                    that.orderCode = data.OrderCode;
                    that.dataList = data.DetailList;
                    that.submitData.EntpCusId = data.EntpCusId;
                    that.IsIn = data.IsIn;
                    if (that.type == 2 || that.type == 4) {
                        if (!that.dataList || that.dataList.length == 0) this.addItem();
                    }
                    that.priceChange(false);
                })
                .catch(error => {});
        },
        // 提交销售售后单
        submitForm(SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = [];
                    if (this.type == 0) _dataList = this.selectedList;
                    else {
                        if (this.dataList.length > 0) {
                            this.dataList.forEach(item => {
                                if (item.EntpTempGoodsId) _dataList.push(item);
                            });
                        }
                    }

                    if (_dataList.length == 0 && this.submitData.ApplyAmount == 0) {
                        this.$util.warningMsg('售后必须至少具备退货或退款其中一项');
                        return;
                    }

                    if (this.submitData.ApplyAmount > 0) {
                        if (!this.submitData.PayType) {
                            this.$util.warningMsg('当申请退款时，退款方式必须选择哟');
                            return;
                        }
                    }

                    if (this.submitData.PayType) {
                        let ml = this.payWayList.filter(f => f.Value === this.submitData.PayType);
                        if (ml.length > 0) {
                            let m = ml[0];
                            if (m.IsSecSpecial) {
                                if (!this.submitData.LogisticId) {
                                    this.$util.warningMsg('当支付方式为托收类型时，物流公司必须进行选择');
                                    return;
                                }
                            }
                        } else {
                            this.$util.warningMsg('支付方式异常，请重新选择支付方式');
                            return;
                        }
                    }

                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }

                        if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
                            this.$util.warningMsg('请填写正确的退货数量');
                            return;
                        }
                        if (!_dataList[i].IsIn && _dataList[i].CanReturnCount && _dataList[i].ReturnCount > _dataList[i].CanReturnCount) {
                            this.$util.warningMsg('可退货数量不足');
                            return;
                        }
                        if (!_dataList[i].IsIn && _dataList[i].WarehousedCount > 0 && _dataList[i].ReturnCount < _dataList[i].WarehousedCount) {
                            this.$util.warningMsg('退货数量不能少于已入仓数，已入仓' + _dataList[i].WarehousedCount + '个商品');
                            return;
                        }
                        if (this.isRemarkShow && this.isForceRemark && !_dataList[i].Remark) {
                            this.$util.warningMsg('请填写备注');
                            return;
                        }
                        if (this.isRemarkSelect && _dataList[i].Remark) {
                            var index = this.remarkList.findIndex(x => x.Text == _dataList[i].Remark);
                            if (index >= 0) {
                                _dataList[i].RemarkId = this.remarkList[index].Id;
                            } else {
                                _dataList[i].RemarkId = '';
                            }
                        } else {
                            _dataList[i].RemarkId = '';
                        }
                    }
                    this.submitData.SubmissionState = SubmissionState;
                    this.submitData.DetailList = _dataList;
                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.DetailList = checkRepeat.row;
                                this.submitFormAgain(SubmissionState);
                            })
                            .catch(() => {});
                    } else {
                        this.submitFormAgain(SubmissionState);
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                }
            });
        },
        submitFormAgain(SubmissionState) {
            let that = this;
            this.stopSubmit = true;
            let url = '';
            if (this.type == 4) {
                url = '/api/EntpSaleReturnOrder/SaveSaleReturnOrderAfterSubmit';
            } else if (this.type == 3 || !this.submitData.EntpCusOId) {
                url = '/api/EntpSaleReturnOrder/SaveEntpSaleDirectReturnOrder';
            } else {
                url = '/api/EntpSaleReturnOrder/SaveEntpSaleReturnOrder';
            }
            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(res => {
                    this.needConfirm = false;
                    if (SubmissionState) {
                        this.$util.successMsg('提交销售售后单成功');
                    } else {
                        this.$util.successMsg('保存销售售后单成功');
                    }
                    this.removePageChace();
                    this.$store.commit('updateNeedRefresh', true);

                    if (that.type == 0 || that.type == 3) that.$store.commit('updateOrderList', { Id: res.data, IsAdd: true });
                    else that.$store.commit('updateOrderList', { Id: that.submitData.SReturnId, IsAdd: false });
                    //添加默认部门,销售售后不给保存后改部门
                    if (that.isOrgShow && that.isLastOrg && that.submitData.OrgId && (that.type == 0 || that.type == 3)) {
                        var og = {
                            OrgId: that.submitData.OrgId,
                            OrgName: that.submitData.OrgName
                        };
                        let CacheList = [];
                        CacheList.push({ CacheKey: 'LastOrderOrg', CacheValue: JSON.stringify(og), CacheType: '1' });
                        that.$util.SetEntpCache(CacheList);
                    }
                    setTimeout(() => {
                        this.$router.push('/ecPlatform/ecReturnManage');
                    }, 2000);
                })
                .catch(() => {
                    this.stopSubmit = false;
                });
        },
        //从缓存中读取上次开单的部门
        getLastOrderOrgId() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                if (this.orgList.length == 0) {
                    this.$util.getParentOrgs().then(data => {
                        this.orgList = data;
                        this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                            if (result) {
                                let orgdata = JSON.parse(result);
                                if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                    this.submitData.OrgId = orgdata.OrgId;
                                    this.submitData.OrgName = orgdata.OrgName;
                                }
                            }
                            resolve();
                        });
                    });
                } else
                    this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                        if (result) {
                            let orgdata = JSON.parse(result);
                            if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                this.submitData.OrgId = orgdata.OrgId;
                                this.submitData.OrgName = orgdata.OrgName;
                            }
                        }
                        resolve();
                    });
            });
        },
        // 将退款方式存入缓存
        setRefundLocalStorage() {
            let refundMethod = this.$util.getLocalStorage('ec_salesRefundMethod');
            if (!Array.isArray(refundMethod)) refundMethod = [];
            let fIdx = refundMethod.findIndex(f => f.EntpCusId === this.submitData.EntpCusId);
            if (fIdx > -1) {
                refundMethod[fIdx].PayType = this.submitData.PayType;
            } else {
                refundMethod.push({
                    EntpCusId: this.submitData.EntpCusId,
                    PayType: this.submitData.PayType
                });
            }
            this.$util.setLocalStorage('ec_salesRefundMethod', refundMethod);
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].ReturnCount = Number(row[index].ReturnCount) + Number(item.ReturnCount);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].ReturnCount = Number(row[index].ReturnCount) + Number(item.ReturnCount);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
        },
        // 删除某行
        delItem(index) {
            this.dataList.splice(index, 1);
            this.priceChange();
        },
        // 添加一行
        addItem() {
            if (this.type * 1 === 0) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }

                if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
                    this.$util.warningMsg('请填写正确的退货数量');
                    return;
                }
                if (_dataList[i].CanReturnCount && _dataList[i].ReturnCount > _dataList[i].CanReturnCount) {
                    this.$util.warningMsg('可退货数量不足');
                    return;
                }
                if (this.isRemarkShow && this.isForceRemark && !_dataList[i].Remark) {
                    this.$util.warningMsg('请填写备注');
                    return;
                }
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.dataList.push({
                EntpTempGoodsId: '',
                SaleQuantity: 0,
                CanReturnCount: 0,
                ReturnCount: 0,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Unit: '',
                SalePrice: 0,
                State: 0,
                WarehousedCount: 0,
                SaleOrderRsId: '',
                CostPrice: 0,
                Brand: ''
            });

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('elx-table--body-wrapper')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            //选中编码下拉框
            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 搜索编码
        searchCode(key) {
            // 取消请求
            if (this.apcodeSource) {
                this.apcodeSource.cancel();
            }
            let url = '';
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            url = '/api/EntpSaleReturnOrder/GetGoodsListByCus';
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            // 初始化对象
            this.apcodeSource = this.axios.CancelToken.source();
            this.loading = true;
            this.$util
                .axiosPost({
                    url: url,
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit,
                        OrderId: this.submitData.EntpCusOId,
                        CusId: this.submitData.EntpCusId,
                        SelectedIds: []
                    },
                    hideLoading: true,
                    cancelToken: this.apcodeSource.token // 取消操作标识
                })
                .then(res => {
                    if (!res.data || res.data.length == 0) {
                        this.$util.warningMsg('已无可退货的商品了');
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 搜索名称
        searchName(key) {
            let url = '';
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            url = '/api/EntpSaleReturnOrder/GetGoodsListByCus';
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosPost({
                    url: url,
                    data: {
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit,
                        OrderId: this.submitData.EntpCusOId,
                        CusId: this.submitData.EntpCusId,
                        SelectedIds: []
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data || res.data.length == 0) {
                        this.$util.warningMsg('已无可退货的商品');
                        return;
                    }
                    this.nameForm.stopLoad = Array.isArray(res.data) && res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                })
                .catch(error => {
                    this.loading = false;
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key, item) {
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.seriesList = [];
            }
            if (this.autoSerieForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleReturnOrder/GetGoodsListByCus',
                    data: {
                        SeriesName: this.autoSerieForm.key,
                        Page: this.autoSerieForm.Page,
                        Limit: this.autoSerieForm.Limit,
                        OrderId: this.submitData.EntpCusOId,
                        CusId: this.submitData.EntpCusId,
                        SelectedIds: []
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data || res.data.length == 0) {
                        this.$util.warningMsg('已无可退货的商品');
                        return;
                    }
                    this.autoSerieForm.stopLoad = res.data.length < this.autoSerieForm.Limit;
                    this.seriesList = this.$util.uniqueArr(this.seriesList, res.data);
                });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        // 名称改变
        nameChange(item, index) {
            if (!this.dataList[index].APCode) {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;
            }
            this.dataList[index].CanReturnCount = item.CanReturnCount;
            this.dataList[index].GoodName = item.GoodName;
            this.dataList[index].Unit = item.Unit;
            this.dataList[index].AutoSerise = item.AutoSerise;
            this.dataList[index].SalePrice = item.SalePrice;
            this.dataList[index].SaleQuantity = item.SaleQuantity;
            this.dataList[index].ReturnCount = item.ReturnCount;
            this.dataList[index].WarehousedCount = item.WarehousedCount;
            this.dataList[index].ReferencePrice = item.MarketPrice;
            this.dataList[index].LatestSalesTime = item.LatestSalesTime;
            this.dataList[index].SaleOrderRsId = item.SaleOrderRsId;
            this.dataList[index].BillingPrice = item.BillingPrice;
            this.dataList[index].Size = item.Size;
            this.dataList[index].Origin = item.Origin;
            this.dataList[index].CostPrice = item.CostPrice;
            this.dataList[index].Brand = item.Brand;
            this.$nextTick(() => {
                this.priceChange();
            });
        },
        // 编码改变
        codeChange(value, index) {
            let _list = this.codeList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EntpTempGoodsId == value) {
                    let item = _list[i];
                    this.dataList[index].APCode = item.APCode;
                    this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                    this.dataList[index].State = 0;
                    this.dataList[index].CanReturnCount = item.CanReturnCount;
                    this.dataList[index].GoodName = item.GoodName;
                    this.dataList[index].Unit = item.Unit;
                    this.dataList[index].AutoSerise = item.AutoSerise;
                    this.dataList[index].SalePrice = item.SalePrice;
                    this.dataList[index].SaleQuantity = item.SaleQuantity;
                    this.dataList[index].ReturnCount = item.ReturnCount;
                    this.dataList[index].CanReturnCount = item.CanReturnCount;
                    this.dataList[index].WarehousedCount = item.WarehousedCount;
                    this.dataList[index].ReferencePrice = item.MarketPrice;
                    this.dataList[index].LatestSalesTime = item.LatestSalesTime;
                    this.dataList[index].SaleOrderRsId = item.SaleOrderRsId;
                    this.dataList[index].BillingPrice = item.BillingPrice;
                    this.dataList[index].Size = item.Size;
                    this.dataList[index].Origin = item.Origin;
                    this.dataList[index].CostPrice = item.CostPrice;
                    this.dataList[index].Brand = item.Brand;
                    break;
                }
            }
            this.$refs[`countRef`].focus();
            this.$nextTick(() => {
                this.priceChange();
            });
        },
        seriseChange(item, index) {
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;
                this.dataList[index].CostPrice = item.CostPrice;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].ReferencePrice = item.ReferencePrice;
                this.dataList[index].MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].WarehousedCount = item.WarehousedCount;
                this.dataList[index].ReferencePrice = item.MarketPrice;
                this.dataList[index].LatestSalesTime = item.LatestSalesTime;
                this.dataList[index].SaleOrderRsId = item.SaleOrderRsId;
                this.dataList[index].BillingPrice = item.BillingPrice;
                this.dataList[index].Size = item.Size;
                this.dataList[index].Origin = item.Origin;
                this.dataList[index].Brand = item.Brand;
                this.$nextTick(() => {
                    this.priceChange();
                });
            }
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
                setTimeout(() => {
                    if (that.codeList && that.codeList.length > 0) {
                        that.codeList = that.codeList.concat([]);
                    }
                }, 2000);
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('', item);
            }
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        that.warehouseType = that.warehouseList[i].Type;
                        break;
                    }
                }
            }
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    if (this.$refs[`sapcode`]) {
                        this.$refs[`sapcode`].focus();
                    }
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    if (this.$refs[`partsNameSelect`]) {
                        this.$refs[`partsNameSelect`].focus();
                    }
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    if (this.$refs[`autoSeriseSelect`]) {
                        this.$refs[`autoSeriseSelect`].focus();
                    }
                }, 200);
            }
        },
        setSummaries(param) {
            let count = this.dataList.reduce((p, i) => p + Number(i.ReturnCount), 0);
            var countColIndex = 0;
            var sumColIndex = 0;
            countColIndex = param.columns.findIndex(item => {
                return item.title == '退货数量';
            });
            sumColIndex = param.columns.findIndex(item => {
                return item.title == '退单总价';
            });

            var arr = new Array(param.columns.length);
            if (countColIndex != -1) {
                arr[countColIndex] = count;
                arr[countColIndex - 1] = '总数量';
            }
            if (sumColIndex != -1) {
                arr[sumColIndex] = this.allMoney.toFixed(2);
                arr[sumColIndex - 1] = '合计';
            }
            return [arr];
        },
        GetSaleOrderDetail() {
            return new Promise(resolve => {
                let that = this;
                that.loading = true;
                that.$util
                    .axiosGet({
                        url: '/api/EntpSaleReturnOrder/GetSaleOrderToReturn',
                        data: { EntpCusOId: that.submitData.EntpCusOId },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        data.LogisticItem = data.LogisticName;
                        let i = that.customerList.findIndex(item => {
                            if (item.EntpCusId == res.data.EntpCusId) {
                                return true;
                            }
                        });
                        if (i == -1) {
                            that.customerList.push({
                                EntpCusId: res.data.EntpCusId,
                                EntpCusName: res.data.EntpCusName
                            });
                            that.entpCusName = res.data.EntpCusName;
                        }

                        if (res.data.WarehouseId) {
                            let iw = that.warehouseList.findIndex(item => {
                                if (item.WarehouseId == res.data.WarehouseId) {
                                    return true;
                                }
                            });
                            if (iw == -1) {
                                that.warehouseList.push({
                                    WarehouseId: res.data.WarehouseId,
                                    WarehouseName: res.data.WarehouseName,
                                    Type: res.data.WarehouseType
                                });
                            }
                        }
                        let ip = that.payWayList.findIndex(item => {
                            if (item.Value == res.data.PayType) {
                                return true;
                            }
                        });
                        if (ip == -1) {
                            that.payWayList.push({
                                Value: res.data.PayType,
                                Text: res.data.PayTypeName
                            });
                        }

                        if (data.OrderSId) {
                            that.SIdList.push({
                                EmployeeId: data.OrderSId,
                                EmployeeName: data.OrderSName
                            });
                        }
                        if (that.isOrgShow && data.OrgId) {
                            that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                        }
                        that.submitData = data;
                        that.returnMoney = data.Paid;
                        that.discountMoney = data.DiscountAmount;
                        that.refundAmount = data.RefundAmount;
                        that.returnCode = '';
                        that.orderCode = data.OrderCode;
                        that.dataList = data.DetailList;

                        if (that.type == 2) {
                            if (!that.dataList || that.dataList.length == 0) that.addItem();
                        }
                        this.$nextTick(() => {
                            that.priceChange();
                        });
                    })
                    .finally(() => {
                        that.loading = false;
                        resolve();
                    });
            });
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        handleSelectionChange(val) {
            this.selectedList = [];
            if (val) this.selectedList = val;
            this.totalPriceSum();
        },
        // 计算申请退款金额
        totalPriceSum() {
            let num = this.selectedList.reduce((r, e) => r + e.SalePrice * e.ReturnCount, 0);
            this.submitData.ApplyAmount = num.toFixed(2);
        },
        selectCustomerChange(val) {
            let that = this;
            if (!val) {
                that.submitData.EntpCusName = '';
                return;
            }
            let rowArr = this.customerList.filter(f => f.EntpCusId === val);
            if (rowArr.length == 1) {
                that.entpCusName = rowArr[0].EntpCusName;
                that.submitData.EntpCusName = rowArr[0].EntpCusName;
            }
            // // 查询缓存是否已有退款方式
            // let refundMethod = this.$util.getLocalStorage("salesRefundMethod");
            // if (Array.isArray(refundMethod)) {
            //   let fIdx = refundMethod.findIndex((f) => f.EntpCusId === val);
            //   if (~fIdx) {
            //     this.submitData.PayType = refundMethod[fIdx].PayType;
            //   }
            // }
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '2'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data && data.PayType) {
                        this.submitData.PayType = data.PayType;
                        let payType = this.payWayList.find(e => e.Value == data.PayType);
                        if (!payType) {
                            this.payWayList.push({
                                Value: data.PayType,
                                Text: data.PayTypeName
                            });
                        }
                    }
                });
        },
        // 搜索
        showSearch() {
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            if (this.entpCusName) this.title = '【' + this.entpCusName + '】销售数据';
            else this.title = '销售数据';
            this.searchVisible = true;
        },
        showOrderSearch() {
            if (!this.submitData.EntpCusOId) {
                this.$util.warningMsg('销售数据异常，请刷新后重试');
                return;
            }
            if (this.entpCusName) this.title = '【' + this.entpCusName + '】销售单【' + this.orderCode + '】明细';
            else this.title = '销售单明细';
            this.searchOrderVisible = true;
        },
        // 搜索配件弹框 - 关闭弹框并更新页面数据
        closeSearchDialog(items, noClose = false) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                if (!noClose) {
                    that.searchVisible = false;
                    that.searchOrderVisible = false;
                    return;
                }
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];

                let newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodsName,
                    AutoSerise: item.AutoSerise,
                    ReturnCount: item.WarehousedCount - item.AlReturnCount > 0 ? item.WarehousedCount - item.AlReturnCount : 0,
                    Unit: item.Unit,
                    SalePrice: item.SalePrice,
                    State: item.State,
                    Size: item.Size,
                    Origin: item.Origin,
                    BillingPrice: item.BillingPrice,
                    SaleOrderRsId: item.SaleOrderRsId,
                    CostPrice: item.CostPrice,
                    Brand: item.Brand
                };

                newGoodsList.push(newGoods);
            }

            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
            if (!noClose) {
                that.searchVisible = false;
                that.searchOrderVisible = false;
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        filterAPCodeMethod({ option, row }) {
            let val = option.data.replace(/(^\s*)|(\s*$)/g, '');
            if (val) {
                val = val.toUpperCase();
            }
            return row.APCode.toUpperCase().indexOf(val) != -1;
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.OrderSName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event && that.SIdList.length <= 1) {
                that.$util.getCommonSIdList().then(data => {
                    that.SIdList = data;
                });
            }
        },
        //获取备注下拉列表
        getRemarkList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAttrs2?attrCode=sOrderReason',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.remarkList = data;
                    }
                });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length == 0) that.searchLogistic();
            }
        },
        searchLogistic(key) {
            this.loading = true;
            this.$util
                .searchLogistic(key, 1, this.Limit)
                .then(data => {
                    this.logisticsList = data ? data : [];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        logisticChange(item) {
            if (!item) {
                this.submitData.LogisticName = '';
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
            } else if (typeof item == 'string') {
                this.submitData.LogisticName = item;
                this.submitData.LogisticId = '';
            } else {
                this.submitData.LogisticName = item.EntpCusName;
                this.submitData.LogisticId = item.EntpCusId;
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'Enter') {
                if (code == 'MarketPrice' || code == 'Remark' || code == 'Count') {
                    that.addItem(true);
                } else {
                    if (code == 'APCode') {
                        that.codeChange(row.APCode, index);
                    } else {
                        that.$refs[`countRef`].focus();
                    }
                }
            } else if (ev.key == 'ArrowLeft') {
                if (code == 'Count') {
                    that.$refs[`autoSeriseSelect`].focus();
                } else if (code == 'MarketPrice') {
                    that.$refs[`countRef`].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    that.$refs[`sapcode`].focus();
                } else if (code == 'AutoSerise') {
                    that.$refs[`autoSeriseSelect`].blur();
                    that.$refs[`partsNameSelect`].focus();
                } else if (code == 'Remark') {
                    that.$refs[`marketPirceRef`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    that.$refs[`marketPirceRef`].focus();
                } else if (code == 'APCode') {
                    that.$refs[`sapcode`].blur();
                    that.$refs[`partsNameSelect`].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    that.$refs[`autoSeriseSelect`].focus();
                } else if (code == 'AutoSerise') {
                    that.$refs[`autoSeriseSelect`].blur();
                    that.$refs[`countRef`].focus();
                } else if (code == 'MarketPrice') {
                    that.$refs[`remarkRef`].focus();
                }
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$set(this.submitData, 'returnMoney', this.returnMoney);
            this.$set(this.submitData, 'discountMoney', this.discountMoney);
            this.$set(this.submitData, 'refundAmount', this.refundAmount);
            this.$set(this.submitData, 'orderCode', this.orderCode);
            this.$set(this.submitData, 'returnCode', this.returnCode);
            this.$set(this.submitData, 'IsIn', this.IsIn);
            this.$util.setLocalStorage('ec_salesReturnOrder', this.submitData);
            this.$util.setLocalStorage('ec_salesReturnOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('ec_salesReturnOrder');
            this.$util.clearLocalStorage('ec_salesReturnOrder_dataList');
        },
        //从缓存中读取数据
        getDataFromChace() {
            return new Promise(resolve => {
                let data = this.$util.getLocalStorage('ec_salesReturnOrder');
                let datalist = this.$util.getLocalStorage('ec_salesReturnOrder_dataList');
                let that = this;
                if (data) {
                    data.LogisticItem = data.LogisticName;
                    let i = that.customerList.findIndex(item => {
                        if (item.EntpCusId == data.EntpCusId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.customerList.push({
                            EntpCusId: data.EntpCusId,
                            EntpCusName: data.EntpCusName
                        });
                        that.entpCusName = data.EntpCusName;
                    }

                    if (data.WarehouseId) {
                        let iw = that.warehouseList.findIndex(item => {
                            if (item.WarehouseId == data.WarehouseId) {
                                return true;
                            }
                        });
                        if (iw == -1) {
                            that.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }
                    }
                    let ip = that.payWayList.findIndex(item => {
                        if (item.Value == data.PayType) {
                            return true;
                        }
                    });
                    if (ip == -1) {
                        that.payWayList.push({
                            Value: data.PayType,
                            Text: data.PayTypeName
                        });
                    }
                    if (data.OrderSId) {
                        that.SIdList.push({
                            EmployeeId: data.OrderSId,
                            EmployeeName: data.OrderSName
                        });
                    }
                    if (that.isOrgShow && data.OrgId) {
                        if (!that.orgList.find(item => item.Id == data.OrgId)) that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }

                    that.submitData = data;
                    that.returnMoney = data.returnMoney;
                    that.discountMoney = data.discountMoney;
                    that.refundAmount = data.refundAmount;
                    that.returnCode = data.returnCode;
                    that.orderCode = data.orderCode;
                    that.IsIn = data.IsIn;
                }
                if (datalist && datalist.length > 0) {
                    that.dataList = datalist;
                }
                that.priceChange(false);
                this.startAddChace = true;
                resolve();
            });
        }
    }
};
</script>
<style lang="less" scoped>
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;

    span {
        margin-right: 20px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    padding-top: 30px;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.info-cus-icon {
    width: 25px;
    height: 25px;
    margin-right: 4px;
    margin-top: -4px;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}
</style>
<style lang="less">
.salereturn-order-edit {
    width: 100%;
    padding: 10px 20px 0px 20px;

    .order-infoes {
        border: 1px solid @border3Color;
        padding-top: 10px;
        margin-bottom: 10px;

        .grid-content {
            border-radius: 4px;
            min-height: 32px;
        }
        .el-form-item {
            margin-bottom: 0px;
            line-height: 32px;
            height: 32px;
        }

        .el-form-item__label {
            line-height: 32px;
            height: 32px;
        }

        .el-form-item__content {
            line-height: 32px !important;
            height: 32px;
            top: -1px;
        }
    }
    .el-row {
        margin-bottom: 10px !important;

        &:last-child {
            margin-bottom: 10px !important;
        }
    }

    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 220px !important;

            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .table-check {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 10px;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
</style>
